import React, { useState, useEffect } from 'react';
import technicalNotesData from '../data/technicalNotes.json';

const TechnicalNotesOverlay = ({ currentTime, inPanel = false, textSize = 100 }) => {
  // Create a style object for the text size
  const textSizeStyle = { fontSize: `${textSize}%` };
  const [currentNote, setCurrentNote] = useState(null);
  
  useEffect(() => {
    // Find the note that corresponds to the current time
    const findCurrentNote = () => {
      // Buffer time (in seconds) to keep a note visible after its timestamp
      const bufferTime = 5;
      
      // Find the note that matches the current time
      const note = technicalNotesData.find(note => {
        return currentTime >= note.seconds && currentTime < note.seconds + bufferTime;
      });
      
      setCurrentNote(note || null);
    };
    
    findCurrentNote();
  }, [currentTime]);
  
  if (!currentNote) {
    return null;
  }
  
  // If this component is being rendered inside the panel, use a different style
  if (inPanel) {
    return (
      <div className="panel-note">
        <div className="flex items-start">
          <div className="mr-2 text-yellow-400 font-bold">
            {currentNote.timestamp}
          </div>
          <div className="flex-1">
            <p className="text-white" style={textSizeStyle}>{currentNote.note}</p>
            
            {currentNote.hasLink && (
              <div className="mt-2">
                <a 
                  href={currentNote.linkUrl} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-block bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded text-sm"
                  style={textSizeStyle}
                >
                  {currentNote.linkText}
                </a>
              </div>
            )}
            
            {currentNote.isWarning && (
              <div className="mt-1 text-red-400 text-sm font-bold" style={textSizeStyle}>
                Warning: Exercise caution with this technique
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
  
  // Default overlay style for video
  return (
    <div className="video-overlay animate-fade-in">
      <div className="flex items-start">
        <div className="mr-2 text-yellow-400 font-bold">
          {currentNote.timestamp}
        </div>
        <div className="flex-1">
          <p className="text-white text-lg" style={textSizeStyle}>{currentNote.note}</p>
          
          {currentNote.hasLink && (
            <div className="mt-2">
              <a 
                href={currentNote.linkUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-block bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded text-sm"
                style={textSizeStyle}
              >
                {currentNote.linkText}
              </a>
            </div>
          )}
          
          {currentNote.isWarning && (
            <div className="mt-1 text-red-400 text-sm font-bold" style={textSizeStyle}>
              Warning: Exercise caution with this technique
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TechnicalNotesOverlay;
